import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import type { ApplyCloseTemplateEntitySelectionRow } from "../applyCloseTemplateEntitySelection.types";
import { ApplyCloseEntityDateCell } from "./ApplyCloseEntityDateCell";

export const ApplyCloseEntityEndDateCell = memo(
    function ApplyCloseEntityEndDateCell({
        row,
    }: CellContext<
        ViewTableFeatures,
        ApplyCloseTemplateEntitySelectionRow,
        string
    >) {
        return (
            <ApplyCloseEntityDateCell
                row={row}
                field="endDate"
                addText="Add end date"
                placeholder="End date..."
            />
        );
    },
);
